import { Tooltip, TooltipProps } from '@mui/material'
import React from 'react'

import Icon from 'components/Icon'
import { muiTheme } from 'mui-theme'

export const InfoTooltip: React.FC<{
  placement?: TooltipProps['placement']
  title: React.ReactNode | string
  type?: 'info' | 'warning'
}> = ({ placement = 'top', title, type = 'info', ...rest }) => {
  return (
    <Tooltip arrow placement={placement} title={title}>
      <Icon
        css={
          type === 'warning'
            ? {
                color: muiTheme.palette.warning.main
              }
            : { color: 'inherit' }
        }
        icon={type === 'warning' ? 'warning' : 'solidCircleInfo'}
        {...rest}
      />
    </Tooltip>
  )
}
